module.exports = __webpack_public_path__ + "img/schemeList03Display01.c92b5358.jpg";